export enum InviteChannelOverrideReason {
  /** candidate explicitly disabled notifications */
  OptedOut = 'opted_out',
  /** assigned channel sending failed, switched to other */
  ChannelFallback = 'channel_fallback',
  /** FF assigned a disabled channel, and the other is enabled */
  ChannelUnavailable = 'channel_unavailable',
}
